import type { SVGProps } from 'react';
const SvgIconCopy = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 1H4a3 3 0 0 0-3 3v5a3 3 0 0 0 3 3 3 3 0 0 0 3 3h5a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3 3 3 0 0 0-3-3m3 4.5V9a3 3 0 0 1-3 3H5.5A1.5 1.5 0 0 0 7 13.5h5a1.5 1.5 0 0 0 1.5-1.5V7A1.5 1.5 0 0 0 12 5.5M2.5 4A1.5 1.5 0 0 1 4 2.5h5A1.5 1.5 0 0 1 10.5 4v5A1.5 1.5 0 0 1 9 10.5H4A1.5 1.5 0 0 1 2.5 9z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconCopy;
